import React from "react"
import {findDOMNode} from "react-dom"

import {FieldTableCellProps, FieldTableCellState, getTableCellStyle} from "../../../../../render/table/table-cell"
import TaskStatusManager from "../../../../../../gd/manager/task-status-manager"
import TaskStatusSelectorPopover from "../../../../../../gd-ui/select-status/task_v2/popover"
import PopoverPosition from "../../../../../../gd-components/gd-popover/popover-position"
import {isBulkSelection} from "../../../../../../gd/right-click-menu";

// const debug = "FieldTaskStatus_TableCell"
const debug = false

export default class FieldTaskStatus_TableCell extends React.Component<FieldTableCellProps, FieldTableCellState> {

    constructor(props:FieldTableCellProps) {
        super(props)

        this.state = {
            isHovered: false,
            showPopover: false
        }
    }

    get canEdit():boolean {
        if (this.props.manager.isReadOnly) return false
        return this.props.field.canEdit(this.props.listItem.item)
    }

    onMouseEnter = () => {
        if (!this.canEdit) return

        if (!this.state.isHovered) this.setState({
            isHovered   : true
        })
    }

    onMouseLeave = () => {
        if (this.state.showPopover) return //

        if (this.state.isHovered) this.setState({
            isHovered   : false
        })
    }

    onValueChange = (value: ID, hidePopover:boolean=true) => {
        this.props.listItem.task.statusId = value

        const status = gd.session.statuses.get(value)

        // if new status is of closed system type then action required user should be unset
        if (gd.const.systemStatus.isClosed(status.systemStatus)) {
            this.props.listItem.task.actionRequiredUserId = null
        }

        this.props.listItem.task.save()

        // no recalculation needed ? or needed ?

        hidePopover && this.hidePopover()

    }

    onClick = (e: React.MouseEvent) => {
        if (isBulkSelection(e)) return
        if (!this.canEdit) return

        this.setState({
            showPopover     : !this.state.showPopover
        })
    }

    hidePopover = () => {
        this.setState({
            showPopover     : false,
            isHovered       : false
        })
    }

    renderValue() {
        const status = gd.session.statuses.get(this.props.listItem.task.statusId)
        if (!status) return false

        return (
            <div className={Classes('ui5-status-list', 'status-c{0}'.f(status.color), this.props.className)}>
                <div className="max-w-100-percent txt-truncate">{status?.name}</div>
            </div>
        )
    }

    renderHovered() {
        const _workflow = TaskStatusManager.getWorkflow(this.props.listItem.task)

        return (
            <div className="cell-flex is-hovered" style={getTableCellStyle(this.props)} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave} >
                <div className="ui5-field-editable size-small is-hovered w-100-percent h-100-percent" onClick={this.onClick}>
                    {this.renderValue()}

                    <div className="buttons flex-no-shrink">
                        <div className="btn-arrow"/>
                    </div>
                </div>

                {this.state.showPopover &&
                    <TaskStatusSelectorPopover hidePopover={this.hidePopover}
                                               task={this.props.listItem.task}
                                               workflow={_workflow}
                                               onStatusSelect={this.onValueChange}
                                               togglePopover={this.hidePopover}
                                               hint={true}
                                               popoverPosition={PopoverPosition.top()}
                                               getTarget={()=>findDOMNode(this)}/>

                    // <field.components.PopoverMenu {...this.props} parent={this} />
                }
            </div>
        )
    }

    renderNotHovered() {
        return (
            <div className="cell-flex border-1px-transparent" style={getTableCellStyle(this.props)} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
                {this.renderValue()}
            </div>
        )
    }

    render() {
        debug && console.log(debug, "render() isHovered=", this.state.isHovered)

        if (this.state.isHovered)   return this.renderHovered()
        else                        return this.renderNotHovered()
    }
}



